import { payoutConstants } from '../constants/payoutConstants';
import { payoutService } from '../../services/API/payoutService';
import { alertActions } from './alert.actions';
import { history }              from '../store/configureStore';
import Alert     from '../../components/alert/Alert';

export const  addPayoutTerms = (postData) => {
    return dispatch => {
        payoutService.addPayoutTerms(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: payoutConstants.POST_PAYOUT_REQUEST, data } }
    function success(data) { return { type: payoutConstants.POST_PAYOUT_SUCCESS, data } }
    function failure(error) { return { type: payoutConstants.POST_PAYOUT_FAILURE, error } }
}

export const  getPayoutList = (postData) => {
    return dispatch => {
        payoutService.getPayoutList(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: payoutConstants.GET_PAYOUTLIST_REQUEST, data } }
    function success(data) { return { type: payoutConstants.GET_PAYOUTLIST_SUCCESS, data } }
    function failure(error) { return { type: payoutConstants.GET_PAYOUTLIST_FAILURE, error } }
}
export const  deletePayout = (postData) => {
    return dispatch => {
        payoutService.deletePayout(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: payoutConstants.DELETE_PAYOUT_REQUEST, data } }
    function success(data) { return { type: payoutConstants.DELETE_PAYOUT_SUCCESS, data } }
    function failure(error) { return { type: payoutConstants.DELETE_PAYOUT_FAILURE, error } }
}
export const  getPayoutTerms = (postData) => {
    return dispatch => {
        payoutService.getPayoutTerms(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: payoutConstants.GET_PAYOUT_REQUEST, data } }
    function success(data) { return { type: payoutConstants.GET_PAYOUT_SUCCESS, data } }
    function failure(error) { return { type: payoutConstants.GET_PAYOUT_FAILURE, error } }
}
export const  updatePayoutTerms = (postData) => {
    return dispatch => {
        payoutService.updatePayoutTerms(postData)
            .then(
                data => { 
                    dispatch(success(data));
                },
               
                error => {
                    dispatch(failure(error.toString()));
                }
            );
    };
 
    function request(data) { return { type: payoutConstants.POST_PAYOUT_REQUEST, data } }
    function success(data) { return { type: payoutConstants.POST_PAYOUT_SUCCESS, data } }
    function failure(error) { return { type: payoutConstants.POST_PAYOUT_FAILURE, error } }
}



// WEBPACK FOOTER //
// ./src/app/redux/actions/payoutActions.js